module.exports = {
      id: "menu-search-usage",
      viewBox: "0 0 28.943 16.863",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#menu-search",
      toString: function () {
        return this.url;
      }
    }